/**
 * 公共使用的接口
 */
import { createAPI } from '../setup'
import hostConfig from '../config'
const COMMON = {
    // 获取外链
    getActivateOutterUrl: (data) => createAPI(`${hostConfig.apiHost}/user/gameActivate/getActivateOutterUrl`, 'post', data),
    // 激活游戏
    verifyGameActivate: (data) => createAPI(`${hostConfig.apiHost}/user/gameActivate/verifyGameActivate`, 'post', data)
}
export default COMMON
